<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div id="page-loader" class="fade show"><span class="spinner"></span></div>
